import React, { useCallback, useMemo } from "react";
import FormFieldVisibilitySettings from "./FormFieldVisibilitySettings";
import { fetchDynamicForm } from "../Master/Products/dynamicFormApi";
import {
  applyProductPriorityFieldDefaults,
  mapDefaultProductFieldRows,
  PRODUCT_PRIORITY_FIELD_ORDER,
  PRODUCT_PRICING_MODE_FILTER,
  PRODUCT_RED_FIELD_NAMES,
  resolveProductSettingsFieldName,
} from "./productFormFieldDefaults";

const EXCLUDED_FIELD_NAMES = new Set([
  "length_unit",
  "width_unit",
  "height_unit",
  "product_type",
  "split",
  "box_prices",
  "box_pricing",
  "box_price_bands",
  "piece_prices",
  "piece_pricing",
  "piece_price_bands",
  "both",
  "both_prices",
  "both_pricing",
]);

const isExcludedField = (field) => {
  const name = resolveProductSettingsFieldName(field?.name || "");
  return EXCLUDED_FIELD_NAMES.has(name);
};

const filterExcludedFields = (fields = []) =>
  (fields || []).filter((field) => !isExcludedField(field));

export default function ProductFormFieldSettings() {
  const defaultFields = useMemo(
    () =>
      applyProductPriorityFieldDefaults(
        filterExcludedFields(mapDefaultProductFieldRows()),
      ),
    [],
  );

  const fetchForm = useCallback(async (args) => {
    const form = await fetchDynamicForm(args);
    return {
      ...form,
      fields: filterExcludedFields(form?.fields),
      sections: (form?.sections || []).map((section) => ({
        ...section,
        fields: filterExcludedFields(section?.fields),
      })),
    };
  }, []);

  return (
    <FormFieldVisibilitySettings
      title="Product Form Fields"
      formKey="add_product"
      module="product"
      fetchForm={fetchForm}
      saveEndpoint="/update_dynamic_form"
      enableSubFields
      defaultFields={defaultFields}
      resolveFieldName={resolveProductSettingsFieldName}
      normalizeRows={applyProductPriorityFieldDefaults}
      lockedFieldNames={PRODUCT_PRIORITY_FIELD_ORDER}
      highlightFieldNames={PRODUCT_RED_FIELD_NAMES}
      modeFilter={PRODUCT_PRICING_MODE_FILTER}
    />
  );
}
